import * as S from "./JoinForm.style";

interface JoinFormProps {
  title?: React.ReactNode;
  text?: React.ReactNode;
  children?: React.ReactNode;
  formButton?: React.ReactNode;
  gridColumn?: string;
  onSubmit?: () => void;
  subTitle?: React.ReactNode;
  alignItems?: "flex-start" | "center";
  textAlign?: "left" | "center";
  textBottom?: React.ReactNode;
  pageIndex?: number;
  totalPage?: number;
  gap?: string;
}

export const JoinForm = ({
  title,
  text,
  children,
  formButton,
  gridColumn,
  onSubmit,
  subTitle,
  alignItems = "center",
  textAlign = "center",
  textBottom,
  pageIndex,
  totalPage,
  gap,
}: JoinFormProps) => {
  return (
    <S.JoinForm $formButton={formButton ? true : false} onSubmit={onSubmit}>
      <S.FormBox
        $formButton={formButton ? true : false}
        $alignItems={alignItems}
        $gap={gap}
      >
        {(title || subTitle || text || pageIndex || totalPage) && (
          <S.FormTitBox>
            {typeof pageIndex === "number" && typeof totalPage === "number" && (
              <S.PageIndicator>
                <span>
                  <S.PageIndex>{pageIndex + 1}</S.PageIndex>
                  <S.PageTotal> / {totalPage}</S.PageTotal>
                </span>
              </S.PageIndicator>
            )}
            {title && <S.FormTit>{title}</S.FormTit>}
            {subTitle && <S.FormSubTit>{subTitle}</S.FormSubTit>}
            {text && <S.FormTxt $textAlign={textAlign}>{text}</S.FormTxt>}
          </S.FormTitBox>
        )}
        <S.FormContent $gridColumn={gridColumn}>{children}</S.FormContent>
      </S.FormBox>
      <S.FormBottom>
        <S.FormInfoTxt>{textBottom && textBottom}</S.FormInfoTxt>
        <S.FormButtonBox>{formButton && formButton}</S.FormButtonBox>
      </S.FormBottom>
    </S.JoinForm>
  );
};
